import { useEffect } from 'react';

interface UseCertificateModalEffectsProps {
  loadCertificate: () => Promise<void>;
}

export const useCertificateModalEffects = ({
  loadCertificate,
}: UseCertificateModalEffectsProps): void => {
  useEffect(() => {
    loadCertificate();
  }, [loadCertificate]);
};
